export const downloadFile = (fileName = '', blob: Blob) => {
  const url = window.URL.createObjectURL(blob);

  // Create a link to trigger the download
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName; // Specify the filename
  a.click();

  // Clean up the URL object
  window.URL.revokeObjectURL(url);
};

export const generateUUID = () => {
  return crypto.randomUUID();
};

export const downloadPDFFile = (fileName: string, content: string) => {
  const blob = new Blob([content], { type: 'application/pdf' });
  downloadFile(fileName, blob);
};

export const downloadExcelFile = (
  fileName: string,
  content: BlobPart | Blob
) => {
  let blob: Blob;
  
  console.log('downloadExcelFile - content type:', typeof content, 'constructor:', content?.constructor?.name);
  
  // ถ้า content เป็น Blob อยู่แล้ว ใช้ได้เลย
  if (content instanceof Blob) {
    blob = content;
  } else if (typeof content === 'string') {
    // ถ้าเป็น base64 string ต้องแปลง
    try {
      const binaryString = atob(content);
      const bytes = new Uint8Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      blob = new Blob([bytes], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
    } catch (e) {
      // ถ้า atob fail อาจจะไม่ใช่ base64 ให้สร้าง Blob ตรง ๆ
      blob = new Blob([content], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
    }
  } else if (content instanceof ArrayBuffer) {
    // ถ้าเป็น ArrayBuffer
    blob = new Blob([content], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
  } else {
    // ถ้าเป็น BlobPart อื่น ๆ สร้าง Blob ใหม่
    blob = new Blob([content], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
  }

  console.log('downloadExcelFile - final blob size:', blob.size, 'type:', blob.type);
  downloadFile(fileName, blob);
};
